import {useEffect, useState} from 'react'

import L from '../leaflet.js'

/**
 * A layer group on the map that lives as long as the component (or until create changes identity, pass a stable
 * function). Clear it or add to it, it is removed with its layers on unmount. By default a plain LayerGroup.
 */
export default function useLayerGroup<T extends L.LayerGroup = L.LayerGroup>(map: L.Map | null, create?: () => T): T | null {
    const [group, setGroup] = useState<T | null>(null)

    useEffect(() => {
        if (!map) {
            return
        }

        const group = create ? create() : L.layerGroup() as T
        group.addTo(map)
        setGroup(group)

        return () => {
            group.remove()
        }
    }, [map, create])

    return group
}
